module.exports = __webpack_public_path__ + "img/terroir-wavy-3.d1001702.jpg";